export const UNKNOWN_USER_ALERT = "UNKOWN_USER_ALERT_TYPE"
export const ERROR_USER_ALERT = "ERROR_USER_ALERT_TYPE"


// WEBPACK FOOTER //
// ./src/Components/checkout/models/userAlertTypes.js